import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { queryClient as qc, querySetting } from 'keys/queryClient'
import { getAssessmentResultsTrackingFetch } from 'store/middlewares/assessment.crud'
import { secretStorage } from 'config'
import { affiliationGroups } from 'keys'

// פאנל הסטטיסטיקות בעמוד "תוצאות הקריאה" — אותו endpoint של עמוד הסטטיסטיקות,
// מסונן לקבוצת "בתי ספר" כמו ברירת המחדל שם
const useStatisticsSideData = (assessmentFilters) => {
    const semesterAndYear = assessmentFilters?.semester_and_year
    const { roleIndex } = useSelector(state => state.user)

    const schoolsGroup = useMemo(() => {
        const { user_data } = secretStorage.getItem("user") || {}
        const { affiliation_groups } = user_data?.[roleIndex]?.user_data || {}
        return affiliation_groups?.find(group => group.name === affiliationGroups.schools)
    }, [roleIndex])

    // כל שנה"ל ולא רק הסמסטר הנוכחי — סימון המבדקים מפגר אחרי הביצוע,
    // וסינון לסמסטר בלבד מציג בתי ספר בודדים (בהתאם לתצוגת עמוד הסטטיסטיקות)
    const schoolYear = semesterAndYear?.school_year

    const { data, isLoading, isError } = useQuery({
        queryKey: [qc.assessmentResultsTrackingByAffiliations, 'presentation', schoolsGroup?.id, schoolYear],
        queryFn: async ({ signal }) => {
            const filters = { ...(schoolsGroup ? { group: schoolsGroup } : {}), semester_and_year: { school_year: schoolYear } }
            const { data } = await getAssessmentResultsTrackingFetch(filters, null, null, signal)
            return data
        },
        ...querySetting
    })

    return useMemo(() => ({
        affiliations: data || [],
        isLoading,
        isError
    }), [data, isLoading, isError])
}

export default useStatisticsSideData
